// client/src/reservations/api/reservationsApi.js
import axiosInstance from '../../../api/axiosInstance';


export async function getBootstrap(businessId) {
  const { data } = await axiosInstance.get(`/reserve/${businessId}/bootstrap`);
  return data;  // { meta, offerings, calendars, live, discounts, fees, edit_rules, preorder }
}


export async function ensureCart(businessId) {
  const { data } = await axiosInstance.post('/carts', { business_id: businessId });
  return data;
}
export async function getCart(cartId) {
  const { data } = await axiosInstance.get(`/carts/${cartId}`);
  return data;
}
export async function addItem(cartId, payload) {
  const { data } = await axiosInstance.post(`/carts/${cartId}/items`, payload);
  return data;
}
export async function deleteItem(cartId, itemId) {
  const { data } = await axiosInstance.delete(`/carts/${cartId}/items/${itemId}`);
  return data;
}

export async function createWaitlist(businessId, payload) {
  const { data } = await axiosInstance.post(`/reserve/${businessId}/waitlist`, payload);
  return data;
}


export async function listRoomPhotos(businessId, roomTypeId) {
  const { data } = await axiosInstance.get(`/reserve/${businessId}/rooms/${roomTypeId}/photos`);
  return data; // { photos: string[] }
}

// client/src/reservations/api/reservationsApi.js
export async function createHolds(businessId, cartId) {
  const { data } = await axiosInstance.post(`/reserve/${businessId}/holds`, { cart_id: cartId });
  return data; // { ok, holds, ttl_min }
}

export async function releaseHolds(businessId, cartId) {
  const { data } = await axiosInstance.delete(`/reserve/${businessId}/holds`, { params: { cart_id: cartId } });
  return data; // { ok: true }
}

export async function startPayment(businessId, cartId) {
  const { data } = await axiosInstance.post(`/reserve/${businessId}/payments/start`, { cart_id: cartId });
  return data; // { url }
}

export async function startEmbeddedPayment(businessId, cartId) {
  const { data } = await axiosInstance.post(`/reserve/${businessId}/payments/embedded`, { cart_id: cartId });
  // { intentType: 'payment'|'setup', clientSecret, customerId, amount, currency }
  return data;
}

export async function getQuote(businessId, cartId) {
  const { data } = await axiosInstance.get(`/reserve/${businessId}/quote`, { params: { cart_id: cartId } });
  return data; // { subtotal, pay_now, hold_amount, pay_later_total, pay_later_schedule, currency, items[] }
}

export async function finalizePayment(businessId, cartId) {
  const { data } = await axiosInstance.post(`/reserve/${businessId}/payments/finalize`, { cart_id: cartId });
  return data; // { ok, hold_intent_id }
}
